import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';
import { LivechatStartService } from 'src/app/services/livechat-start/livechat-start.service';

@Component({
  selector: 'app-device-permissions',
  templateUrl: './device-permissions.component.html',
  styleUrls: ['./device-permissions.component.scss']
})
export class DevicePermissionsComponent implements OnInit {
  appLabels;
  permissions =  {
    audio: false,
    video: false,
    location: false,
    webrtc: false,
    screenshare: false
  };
  actionsToRight: boolean;

  enabledPermissions = {};
  
  canProceed: boolean = false;
  proceedText: string = 'Proceed';
  appConfig: any;
  locationDisabled: boolean = false;
  proceedLoading: boolean = false;

  constructor(private commInterface: CommunicationInterfaceService,
    public dialogRef: MatDialogRef<DevicePermissionsComponent>, private liveChatService: LivechatStartService, private appDataService: AppdataService) {
  
  }

  ngOnInit(): void {
    this.appConfig = this.appDataService.getConfig();
    this.appLabels = this.appDataService.getLabels();
    this.actionsToRight = this.appConfig.Miscellaneous.ButtonArrangement.actionsToRight;
    this.commInterface.permissionsObservable.subscribe({
      next: (permission) => {
        setTimeout(() => {
          this.proceedText = permission.proceedText;
          this.permissions[permission.type] = permission.status;
          this.checkForMediaRestrictions();
        }, 1000);
      }
    });

    this.setEnabledPermissions();
    this.permissions =  this.commInterface.devicePermissions;
    if(!this.appConfig.GeoLocation.Enable){
      this.locationDisabled = true;
    }
    console.log(this.permissions);    
    this.checkForMediaRestrictions();
    
  }

  setEnabledPermissions() {
    try{
      this.enabledPermissions = this.permissions;
      const permissionsOnChannel = this.appConfig.channelConfiguration[this.appConfig.channelConfiguration.chatmode];
      this.enabledPermissions['audio'] = permissionsOnChannel['audioEnabled'];
      this.enabledPermissions['video'] = permissionsOnChannel['videoEnabled'];
      this.enabledPermissions['location'] = this.appConfig.GeoLocation.Enable;
      this.enabledPermissions['screenshare'] = permissionsOnChannel['screenShareEnabled'];
    } catch(e) {
      console.log('error occured on setting enabled permissions', e);
    }
    
  }

  togglePermission(permissionKey, e?) {   
    e?.preventDefault();   
    switch(permissionKey) {
      case 'location': this.liveChatService.getLocation();
      break;
      default: this.commInterface.getAudioVideoInputs();
      break;
    }
  }

  checkForMediaRestrictions() {
    if(!this.appConfig?.permissionsConfig?.allowToProceedWithoutMedia && (!this.permissions.audio || !this.permissions.video)) {
      this.canProceed = false;
    } else {
      this.canProceed = true;
    }

    this.checkToAutoProceed();
  }

  checkToAutoProceed() {
    if(this.canProceed && this.appConfig?.permissionsConfig?.autoProceedPermissionsCheck) {
      this.proceedLoading = true;
      setTimeout(() => {
        this.proceedLoading = false;
        this.dialogRef.close();
      }, 1500);
    }
  }

}
